@if (loading) {
  <div class="checkout-loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
}

@if (!loading) {
  <section class="checkout-section">
    <div class="container">

      <div class="checkout-page-header">
        <h2 class="checkout-page-title">
          <span class="material-icons">receipt_long</span>
          {{'checkout.billing-details' | translate}}
        </h2>
        <a [routerLink]="['/home']" class="checkout-back-mobile">
          <span class="material-icons">arrow_back</span>
          {{'cart-table.continue-shopping' | translate}}
        </a>
      </div>

      <form [formGroup]="checkoutForm">
        <div class="checkout-layout">

          <!-- ── LEFT: Form ──────────────────────────────────────────── -->
          <div class="checkout-form-col">

            <!-- Section: Contact -->
            <div class="form-section">
              <h4 class="form-section__title">
                <span class="material-icons">person_outline</span>
                Datos de contacto
              </h4>
              <div class="form-grid">

                <div class="field-group">
                  <label class="field-label">{{'customer-name' | translate}} <span class="field-required">*</span></label>
                  <input class="field-input" [formControl]="checkoutForm.controls['firstname']"
                    [class.field-input--error]="checkoutForm.controls.firstname.touched && checkoutForm.controls.firstname.errors?.required"
                    type="text" autocomplete="off" placeholder="Nombre">
                  @if (checkoutForm.controls.firstname.touched && checkoutForm.controls.firstname.errors?.required) {
                    <span class="field-error">{{'customer-name-required' | translate}}</span>
                  }
                </div>

                <div class="field-group">
                  <label class="field-label">{{'customer-lastname' | translate}}</label>
                  <input class="field-input" [formControl]="checkoutForm.controls['lastname']"
                    type="text" autocomplete="off" placeholder="Apellido">
                </div>

                <div class="field-group">
                  <label class="field-label">{{'customer-phone' | translate}} <span class="field-required">*</span></label>
                  <input class="field-input" [formControl]="checkoutForm.controls['phone']"
                    [class.field-input--error]="checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.required"
                    type="text" autocomplete="off" placeholder="Teléfono">
                  @if (checkoutForm.controls.phone.touched && checkoutForm.controls.phone.errors?.required) {
                    <span class="field-error">{{'customer-phone-required' | translate}}</span>
                  }
                </div>

                <div class="field-group">
                  <label class="field-label">{{'customer-email' | translate}}</label>
                  <input class="field-input" [formControl]="checkoutForm.controls['email']"
                    [class.field-input--error]="checkoutForm.controls.email.touched && checkoutForm.controls.email.invalid"
                    type="text" autocomplete="off" placeholder="Correo electrónico">
                  @if (checkoutForm.controls.email.touched && checkoutForm.controls.email.errors?.email) {
                    <span class="field-error">{{'customer-email-invalid' | translate}}</span>
                  }
                </div>

              </div>
            </div>

            <!-- Section: Delivery -->
            <div class="form-section">
              <h4 class="form-section__title">
                <span class="material-icons">local_shipping</span>
                Entrega
              </h4>
              <div class="form-grid">

                <!-- TODO: reactivar modalidad de envío — restaurar el select con deliveryOption -->
                <div class="field-group field-span-2">
                  <label class="field-label">Modalidad de envío</label>
                  <input class="field-input" type="text" value="Retiro en el local" disabled>
                </div>

                <div class="field-group field-span-2">
                  <label class="field-label">{{'branch' | translate}} <span class="field-required">*</span></label>
                  <select class="field-select"
                    [class.field-input--error]="checkoutForm.controls.branch.touched && checkoutForm.controls.branch.errors?.required"
                    [formControl]="checkoutForm.controls['branch']">
                    <option value="" disabled>Seleccioná una sucursal</option>
                    @for (branch of branchList; track branch) {
                      <option [value]="branch.id">{{branch.businessName}}</option>
                    }
                  </select>
                  @if (checkoutForm.controls.branch.touched && checkoutForm.controls.branch.errors?.required) {
                    <span class="field-error">{{'checkout-branch-required' | translate}}</span>
                  }
                </div>

                <div class="field-group field-span-2">
                  <label class="field-label">{{'customer-address' | translate}}</label>
                  <input class="field-input" [formControl]="checkoutForm.controls['address']"
                    type="text" autocomplete="off" placeholder="Dirección">
                </div>

                <div class="field-group">
                  <label class="field-label">{{'customer-city' | translate}}</label>
                  <input class="field-input" [formControl]="checkoutForm.controls['town']"
                    type="text" autocomplete="off" placeholder="Ciudad">
                </div>

                <div class="field-group">
                  <label class="field-label">{{'customer-state' | translate}}</label>
                  <input class="field-input" [formControl]="checkoutForm.controls['state']"
                    type="text" autocomplete="off" placeholder="Provincia">
                </div>

                <div class="field-group">
                  <label class="field-label">{{'customer-postalcode' | translate}}</label>
                  <input class="field-input" [formControl]="checkoutForm.controls['postalcode']"
                    type="text" autocomplete="off" placeholder="Código postal">
                </div>

              </div>
            </div>

          </div>

          <!-- ── RIGHT: Order summary + payment ─────────────────────── -->
          <div class="checkout-summary-col">
            <div class="summary-card">

              <div class="summary-header">
                <span class="summary-header__title">Tu pedido</span>
                <span class="summary-header__count">{{ checkOutItems.length }} {{ checkOutItems.length === 1 ? 'item' : 'items' }}</span>
              </div>

              <div class="summary-items">
                @if (!checkOutItems.length) {
                  <p class="summary-empty">{{'cart-empty' | translate}}</p>
                }
                @for (item of checkOutItems; track item) {
                  <div class="summary-item">
                    <span class="summary-item__name">
                      {{ item.product.name }}
                      <span class="summary-item__qty">× {{ item.quantity }}</span>
                    </span>
                    <span class="summary-item__total">
                      {{ getPrice(item) * item.quantity | currency }}
                    </span>
                  </div>
                }
              </div>

              <div class="summary-totals">
                <div class="summary-line">
                  <span>Subtotal</span>
                  <span>{{ getSubTotal() | async | currency }}</span>
                </div>
                @if (showShippingCost()) {
                  <div class="summary-line">
                    <span>Envío</span>
                    <span>{{ shippingCost | currency }}</span>
                  </div>
                }
                <div class="summary-line summary-line--total">
                  <span>Total</span>
                  <span>{{ getTotal() | async | currency }}</span>
                </div>
              </div>

              <div class="payment-section">
                @if (checkOutItems.length && (isWholesaler$ | async)) {
                  <div class="payment-option">
                    <div class="payment-option__header">
                      <span class="material-icons">store</span>
                      <div>
                        <p class="payment-option__title">Pagá en el local</p>
                        <p class="payment-option__desc">Preparamos tu pedido y pagás al retirar. Aceptamos efectivo, tarjeta y transferencia.</p>
                      </div>
                    </div>
                    <button mat-raised-button color="primary" class="payment-btn"
                      [disabled]="!checkoutForm.valid"
                      (click)="stripeCheckout()">
                      {{'checkout.place-order' | translate}}
                    </button>
                  </div>
                }

                <!-- TODO: reactivar MercadoPago cuando sea necesario -->
                <!-- <app-mercado-pago
                  [formGroup]="checkoutForm"
                  [armarListadoProductos]="armarListadoProductos()"
                  [getBasketCustomer]="getBasketCustomer()"
                  [getCustomer]="getCustomer()"
                  [getBranch]="getBranch()">
                </app-mercado-pago> -->
              </div>

              <button [routerLink]="['/home']" mat-button class="back-btn">
                <span class="material-icons">arrow_back</span>
                {{'cart-table.continue-shopping' | translate}}
              </button>

            </div>
          </div>

        </div>
      </form>

    </div>
  </section>
}
